import React from 'react'
import styled, { useTheme as useStyledTheme } from 'styled-components'
import { Flex, Text } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'
import { EcoFarmConfig } from 'config/constants/ecoBoost'
import { useGetEcoBoostFactor } from 'views/Farms/hooks/useGetEcoBoostFactor'
import { getArgoMintedUrl } from 'utils/mintedNftCollectionUrls'
import { StyledTextWithUrl } from 'components/Text/StyledTextWithUrl'

const ItemText = styled(Text)`
  display: list-item;
  font-size: 14px;
  margin-left: 1em;
`

const EcoBoostInfo: React.FC<{
  ecoFarm: EcoFarmConfig
  farmId: number
}> = ({ ecoFarm, farmId }) => {
  const { t } = useTranslation()
  const { colors } = useStyledTheme()
  const { data: ecoBoostFactor, isLoading } = useGetEcoBoostFactor(farmId)

  if (!isLoading && ecoBoostFactor > 1) {
    return (
      <Flex flexDirection="column" gap="4px">
        <Text fontSize="13px" lineHeight="18px" textTransform="uppercase" color={colors.white}>
          {t('total boost factor')}
        </Text>
        <Text fontSize="28px" lineHeight="36px" color={colors.white}>
          {`${ecoBoostFactor}x`}
        </Text>
      </Flex>
    )
  }

  return (
    <Flex flexDirection="column" gap="4px">
      <Text color={colors.white}>
        {t('Stake %nftName% NFTs to boost %name% farm APR', {
          name: ecoFarm.name,
          nftName: ecoFarm.nftName,
        })}
      </Text>
      <ItemText color={colors.white}>
        {t('%maxStakedNum% NFTs max. NFT staking limit', {
          maxStakedNum: ecoFarm.maxStakedNum,
        })}
      </ItemText>
      <ItemText color={colors.white}>
        {t('%eachBoost% boost for each staked NFT', {
          eachBoost: `${ecoFarm.boostFactorPerNFT * 100}%`,
        })}
      </ItemText>
      <ItemText color={colors.white}>
        {t('%maxBoost%x max. boost factor', {
          maxBoost: `${1 + ecoFarm.maxStakedNum * ecoFarm.boostFactorPerNFT}`,
        })}
      </ItemText>
      <StyledTextWithUrl
        small
        color={colors.white}
        linkColor="primary"
        isBold
        dangerouslySetInnerHTML={{
          __html: t('You can start staking your %urlOpenTag%%nftName% NFTs%urlCloseTag% for additional boost.', {
            urlOpenTag: `<a href="${getArgoMintedUrl()}" target="_blank" rel="noreferrer">`,
            urlCloseTag: '</a>',
            nftName: ecoFarm.nftName,
          }),
        }}
      />
    </Flex>
  )
}

export default EcoBoostInfo
